import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FormFieldModule} from '../../../../../core/component/form-field/form-field.module';
import {EmailContentFormComponent} from './email-content-form.component';
import {InputTextModule} from '../../../../../core/component/input-text/input-text.module';
import {EmailInputModule} from '../../../../../common/email/component/email-input/email-input.module';
import {RichTextEditorModule} from '../../../../../../components/common/rich-text-editor/rich-text-editor.module';
import {
    CommunicationContentEditorModule
} from "../../../../common/api/component/communication-content-editor/communication-content-editor.module";
import {
    DocumentMultipleSelectFilterModule
} from "../../../../../document/common/api/component/document-multiple-select-filter/document-multiple-select-filter.module";
import {LoadingModule} from "../../../../../../components/common/loading/loading.module";
import {ErrorTextModule} from "../../../../../core/component/error-text/error-text.module";
import {
    CommunicationConfigurationEmailSenderSelectComponent
} from "../../../../configuration/email/sender/api/component/communication-configuration-email-sender-select/communication-configuration-email-sender-select.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        FormFieldModule,
        InputTextModule,
        EmailInputModule,
        RichTextEditorModule,
        CommunicationContentEditorModule,
        DocumentMultipleSelectFilterModule,
        LoadingModule,
        ErrorTextModule,
        CommunicationConfigurationEmailSenderSelectComponent,
    ],
    declarations: [
        EmailContentFormComponent,
    ],
    exports: [
        EmailContentFormComponent
    ],
})
export class EmailContentFormModule {
}
